var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lawEnforcement_detail" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "配置项",
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "检查编码：", prop: "code" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入检查编码",
                            },
                            model: {
                              value: _vm.form.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "code", $$v)
                              },
                              expression: "form.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "检查环节：", prop: "type" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "type", $$v)
                                },
                                expression: "form.type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "开标", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "评标", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "检查内容：", prop: "content" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: "4",
                              clearable: "",
                              placeholder: "请输入检查内容",
                            },
                            model: {
                              value: _vm.form.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "content", $$v)
                              },
                              expression: "form.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "序号：", prop: "sort" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入序号" },
                            model: {
                              value: _vm.form.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sort", $$v)
                              },
                              expression: "form.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8, offset: 18 } },
                    [
                      _c("el-button", { on: { click: _vm.handleClose } }, [
                        _vm._v("取消"),
                      ]),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "debounce",
                              rawName: "v-debounce",
                              value: [_vm.submit, "click", 300, "form"],
                              expression: "[submit,'click',300,'form']",
                            },
                          ],
                          attrs: { type: "primary" },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }